var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptySearchStateIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 513,
    height: 346,
    viewBox: "0 0 513 346",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-580 -314) translate(580 314)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#E6E6E6",
    opacity: 0.2,
    transform: "translate(73 150)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 169,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 353,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 374,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 415,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 25,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 25,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 25,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 25,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107,
    cy: 25,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 25,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148,
    cy: 25,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 169,
    cy: 25,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 25,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 25,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 25,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251,
    cy: 25,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 25,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292,
    cy: 25,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312,
    cy: 25,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333,
    cy: 25,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 353,
    cy: 25,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 374,
    cy: 25,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395,
    cy: 25,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 415,
    cy: 25,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436,
    cy: 25,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 46,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 46,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 46,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 46,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 46,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107,
    cy: 46,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 46,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148,
    cy: 46,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 169,
    cy: 46,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 46,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 46,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 46,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251,
    cy: 46,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 46,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292,
    cy: 46,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312,
    cy: 46,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333,
    cy: 46,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 353,
    cy: 46,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 374,
    cy: 46,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395,
    cy: 46,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 415,
    cy: 46,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436,
    cy: 46,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 67,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 67,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 67,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 67,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 67,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107,
    cy: 67,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 67,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148,
    cy: 67,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 169,
    cy: 67,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 67,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 67,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 67,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251,
    cy: 67,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 67,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292,
    cy: 67,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312,
    cy: 67,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333,
    cy: 67,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 353,
    cy: 67,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 374,
    cy: 67,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395,
    cy: 67,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 415,
    cy: 67,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436,
    cy: 67,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 88,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 88,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 88,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 88,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 88,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107,
    cy: 88,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 88,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148,
    cy: 88,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 169,
    cy: 88,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 88,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 88,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 88,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251,
    cy: 88,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 88,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292,
    cy: 88,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312,
    cy: 88,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333,
    cy: 88,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 353,
    cy: 88,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 374,
    cy: 88,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395,
    cy: 88,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 415,
    cy: 88,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436,
    cy: 88,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 108,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 108,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 108,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 108,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 108,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107,
    cy: 108,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 108,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148,
    cy: 108,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 169,
    cy: 108,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 108,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 108,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 108,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251,
    cy: 108,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 108,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292,
    cy: 108,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312,
    cy: 108,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333,
    cy: 108,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 353,
    cy: 108,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 374,
    cy: 108,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395,
    cy: 108,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 415,
    cy: 108,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436,
    cy: 108,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 129,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 129,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 129,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 129,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 129,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107,
    cy: 129,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 129,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148,
    cy: 129,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 169,
    cy: 129,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 129,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 129,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 129,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251,
    cy: 129,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 129,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292,
    cy: 129,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312,
    cy: 129,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333,
    cy: 129,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 353,
    cy: 129,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 374,
    cy: 129,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395,
    cy: 129,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 415,
    cy: 129,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436,
    cy: 129,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 150,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 150,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 150,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 150,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 150,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107,
    cy: 150,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 150,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148,
    cy: 150,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 169,
    cy: 150,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 150,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 150,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 150,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251,
    cy: 150,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 150,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292,
    cy: 150,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312,
    cy: 150,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333,
    cy: 150,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 353,
    cy: 150,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 374,
    cy: 150,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395,
    cy: 150,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 415,
    cy: 150,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436,
    cy: 150,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 171,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 171,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 171,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 171,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 171,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107,
    cy: 171,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 171,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148,
    cy: 171,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 169,
    cy: 171,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 171,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 171,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 171,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251,
    cy: 171,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 171,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292,
    cy: 171,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312,
    cy: 171,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333,
    cy: 171,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 353,
    cy: 171,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 374,
    cy: 171,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395,
    cy: 171,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 415,
    cy: 171,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436,
    cy: 171,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 192,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 192,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 192,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 192,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 192,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107,
    cy: 192,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 192,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148,
    cy: 192,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 169,
    cy: 192,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 192,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 192,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 192,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251,
    cy: 192,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 192,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292,
    cy: 192,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312,
    cy: 192,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333,
    cy: 192,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 353,
    cy: 192,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 374,
    cy: 192,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395,
    cy: 192,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 415,
    cy: 192,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436,
    cy: 192,
    r: 4
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M465 331.5c-1.498 13.215-80.119 12.106-80 0 1.498-13.215 80.119-12.106 80 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB8B8",
    d: "M411 297.067L407.75 304 401.791 303.467 398 291.2 403.958 288zM430.875 312.513L431 317.454 422 318 422 312z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2F2E41",
    d: "M427.836 225.416L425.727 267.794 431 313.881 415.182 316 405.164 257.73 402 218z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2F2E41",
    d: "M452.486 210.628s6.31 41.675-6.837 55.39C432.502 279.734 414.622 304 414.622 304L402 288.174l32.08-34.289-6.311-23.21L402 218.54l4.207-29.013 37.865-.528 8.414 21.628z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.5,
    cy: 101.5,
    r: 11.5,
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB8B8",
    d: "M431.417 104s.533 16.607 3.203 18.75c2.67 2.143-9.61 11.25-9.61 11.25L417 121.143v-11.786L431.417 104z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D0CDE1",
    d: "M426.787 126.705L433.156 117 436.754 121.941 442 136.765 437.803 194.47 413.147 195 410 128.823 417.868 119.294z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2F2E41",
    d: "M399.706 130.53l-4.235-.53s-1.06.53-1.589 4.235c-.53 3.706-6.882 36.53-6.882 36.53L395.47 211l9.53-12.706-5.824-22.235L405 153.824l-5.294-23.295zM453.182 130L456.273 130 464 172.75 456.788 206 449.576 193.861 451.636 180.666 450.606 169.056 447 162.194zM405.883 302.161s3.117-1.049 3.117 1.05c0 2.097-2.078 8.39-2.078 8.39s3.117 19.407-1.559 18.358c-4.676-1.049-8.313-9.965-8.833-12.588-.52-2.622-3.117-16.259-3.117-16.259s-4.157-9.965-1.559-10.49c2.598-.524 9.872-2.622 9.872-2.622s-4.157 13.112 4.157 14.161zM421.248 317.684s8.703-5.261 10.334-1.052c1.083 3.07 1.812 6.246 2.176 9.47 0 0 2.176 6.84-6.527 5.788-8.703-1.052-7.615-1.052-8.16-4.21-.543-3.156 2.177-9.996 2.177-9.996zM428.587 102.208l-2.111-.534s-1.584-9.079-5.279-8.01C417.502 94.73 408 95.798 408 91.526s8.974-8.01 14.253-7.476c5.279.534 14.253 2.136 13.725 10.146-.528 8.01-3.934 15.803-3.934 15.803l-.276-4.75-3.18-3.042z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D0CDE1",
    d: "M417.092 133L426 126.538 417.092 119 414 122.814zM434.895 132L427 126.31 433.316 117 437 121.655z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2F2E41",
    d: "M396 130.358l16.88-6.868 3.957-2.905 11.869 52.563 7.912-23.773L434.245 119l21.891 11.358-7.385 35.922-1.055 13.735 3.165 11.094s11.078 7.924 7.385 16.376c-3.692 8.452-7.912 8.98-7.912 8.98s-17.936-16.904-18.99-21.13c-1.056-4.226-2.638-11.622-2.638-11.622s-8.968 33.81-19.518 33.28c-10.55-.527-10.55-11.621-10.55-11.621l2.637-11.622 4.22-12.15-2.11-20.074L396 130.358z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M0 0H368V236H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M11 30H358V120H11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M97 43H170V47H97z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD98A",
    d: "M97 58H210V62H97z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M97 73H189V77H97zM97 87H151V91H97zM97 102H178V106H97zM64 41H73V50H64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD98A",
    d: "M64 56H73V65H64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M64 70H73V79H64zM64 85H73V94H64zM64 99H73V108H64zM279 62H309V92H279z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M11 132H358V222H11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M79 140H88V149H79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD98A",
    d: "M64 140H73V149H64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M216.482 160c-5.591-9.581-15.387-15.863-26.334-16.886-10.947-1.024-21.714 3.335-28.944 11.717l-2.204-1.95c7.847-9.1 19.534-13.832 31.417-12.721 11.882 1.11 22.515 7.93 28.583 18.331L216.482 160z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD98A",
    d: "M217.504 198L215 196.392c7.567-10.779 7.988-24.748 1.082-35.924l2.596-1.468c7.499 12.133 7.042 27.299-1.174 39zM159.756 202c-12.887-13.914-13.022-34.933-.314-49l2.269 1.917c-11.707 12.959-11.583 32.322.289 45.14L159.756 202z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD98A",
    d: "M186.428 214c-10.469-.008-20.44-4.486-27.428-12.318l2.16-1.943c6.983 7.84 17.18 11.997 27.627 11.266 10.447-.73 19.972-6.269 25.807-15.005l2.406 1.625c-6.835 10.239-18.3 16.38-30.572 16.375z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M279 160H309V190H279zM62 179H92V209H62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AAC5FF",
    d: "M0 0H368V16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 8,
    r: 3,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 8,
    r: 3,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 8,
    r: 3,
    fill: "#FFF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptySearchStateIllustration);
export default __webpack_public_path__ + "static/media/empty-search-state-illustration.d392edd7.svg";
export { ForwardRef as ReactComponent };